import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-component-tester',
  template: `
    <div class="component-tester">
      <div class="controls">
        <h3>Component Tester</h3>
        <div class="component-selector">
          <label>Select Component:</label>
          <select [(ngModel)]="selectedComponent">
            <option value="search-start">Search Start</option>
            <option value="search-start-v2">Search Start V2</option>
            <option value="search-results">Search Results</option>
            <option value="search-results-v2">Search Results V2</option>
            <option value="carefindr-ai">CareFindr AI</option>
          </select>
        </div>
      </div>
      
      <div class="component-display" [ngSwitch]="selectedComponent">
        <!-- Add your components here for direct testing -->
        <div *ngSwitchCase="'search-start'" class="component-wrapper">
          <h4>Search Start Component</h4>
          <!-- <app-search-start></app-search-start> -->
          <p>Add your search-start component here</p>
        </div>
        
        <div *ngSwitchCase="'search-start-v2'" class="component-wrapper">
          <h4>Search Start V2 Component</h4>
          <!-- <app-search-start-v2></app-search-start-v2> -->
          <p>Add your search-start-v2 component here</p>
        </div>
        
        <div *ngSwitchCase="'search-results'" class="component-wrapper">
          <h4>Search Results Component</h4>
          <!-- <app-search-results></app-search-results> -->
          <p>Add your search-results component here</p>
        </div>
        
        <div *ngSwitchCase="'search-results-v2'" class="component-wrapper">
          <h4>Search Results V2 Component</h4>
          <!-- <app-search-results-v2></app-search-results-v2> -->
          <p>Add your search-results-v2 component here</p>
        </div>
        
        <div *ngSwitchCase="'carefindr-ai'" class="component-wrapper">
          <h4>CareFindr AI Component</h4>
          <!-- <app-carefindr-ai></app-carefindr-ai> -->
          <p>Add your carefindr-ai component here</p>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .component-tester {
      padding: 20px;
    }
    
    .controls {
      background: #f0f0f0;
      padding: 15px;
      border-radius: 8px;
      margin-bottom: 20px;
    }
    
    .component-selector {
      margin-top: 10px;
    }
    
    .component-selector label {
      display: block;
      margin-bottom: 5px;
      font-weight: bold;
    }
    
    .component-selector select {
      padding: 8px;
      border: 1px solid #ccc;
      border-radius: 4px;
    }
    
    .component-display {
      border: 2px solid #ddd;
      border-radius: 8px;
      padding: 20px;
      min-height: 400px;
    }
    
    .component-wrapper h4 {
      margin: 0 0 15px 0;
      color: #333;
      border-bottom: 1px solid #eee;
      padding-bottom: 8px;
    }
  `]
})
export class ComponentTesterComponent implements OnInit {
  selectedComponent: string = 'search-start';

  constructor() { }

  ngOnInit(): void {
  }
}
